<nav>
  <div class="navbar-wrapper">
    <div class="m-header" style="justify-content: center; margin-top: 5px">
      <a href="javascript:" class="b-brand">
        <img src="assets/images/wipa_logo.svg" alt="theme-logo" class="logo logo-dark logo-lg" style="height: 2.7rem" />
      </a>
    </div>
    <app-nav-content (NavCollapsedMob)="navCollapseMob()" class="scroll-div w-100 compact"></app-nav-content>
  </div>
</nav>
